import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { FormControl, Typography, Button } from "@mui/material";
import { withStyles } from "@mui/styles";
import client from "common/admin/client";
import Panel from "common/components/Panel";
import SimpleSnackbar from "common/components/SimpleSnackbar";
import LocationDialog from "./LocationDialog";
import Grid from "@mui/material/Grid2";

const fieldStyles = ({ spacing }) => ({
  formControl: {
    marginTop: spacing(1),
  },
  label: {
    fontWeight: "bold",
  },
});

class Location extends Component {
  state = {
    dialogOpen: false,
    error: null,
    location: null,
  };

  componentDidMount() {
    this.loadLocation();
  }

  loadLocation = async () => {
    const location = await client.get(
      `users/${this.props.user.id}/location_v2`,
    );
    this.setState({ location });
  };

  toggleDialog = (opts = {}) => {
    if (opts.updated) {
      this.loadLocation();
    }

    this.setState((prevState) => {
      const newState = { ...prevState, dialogOpen: !prevState.dialogOpen };
      if (opts.error) {
        newState.error = opts.error;
      }
      return newState;
    });
  };

  render() {
    const { user } = this.props;
    const { dialogOpen, error, location } = this.state;
    const tenantName = location?.building?.tenant_name || "N/A";

    return (
      <Panel title="Location">
        <Grid container direction="column">
          <Grid size={{ xs: 12 }}>
            {location ? (
              <Fragment>
                <Field title="City" value={location.city.name} />
                <Field title="Neighborhood" value={location.community.name} />
                <Field title="Building" value={location.building.name} />
                <Field title="Source" value={tenantName} />
                <Field title="Company" value={location.company?.name} />
                <Field title="Floor" value={location.floor.level} />
                <Field title="Suite" value={location.unit.name} />
              </Fragment>
            ) : (
              <Grid size={{ xs: 12 }}>
                <Typography>No location set.</Typography>
                <Field title="Source" value={tenantName} />
              </Grid>
            )}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Button variant="contained" onClick={this.toggleDialog}>
              Change
            </Button>
          </Grid>
        </Grid>
        <LocationDialog
          open={dialogOpen}
          onClose={this.toggleDialog}
          user={user}
        />
        {error ? (
          <SimpleSnackbar message="An error occurred. Please try again." />
        ) : null}
      </Panel>
    );
  }
}

Location.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const Field = withStyles(fieldStyles)(({ title, value, classes }) => (
  <FormControl fullWidth className={classes.formControl}>
    <Typography variant="body2" className={classes.label}>
      {title}
    </Typography>
    <Typography variant="body1">{value}</Typography>
  </FormControl>
));

export default Location;
